console.log('crodino');

$(".jobs-popup__trigger").on("click", function(e) {
  e.preventDefault();

  const title = $(this)
    .parents(".o-job")
    .find(".o-job__title")
    .text();

  const content = $(this)
    .parents(".o-job")
    .data("content");

  $(".o-popup--job")
    .find(".o-job-popup__title")
    .text(title);

  $(".o-popup--job")
    .find('input[name="o-candidatura"]')
    .val(title);

  $(".o-popup--job")
    .find(".o-job-popup__content")
    .html(content);

  $(".backplate").addClass("backplate--open");
  $(".o-popup--job").addClass("o-popup--open");
});

$(".backplate,.o-popup__close").on("click", function() {
  $(".o-popup--job").removeClass("o-popup--open");
  $(".backplate").removeClass("backplate--open");
});

$("#wpcf7-f767-o1").on("wpcf7mailsent", function() {
  setTimeout(() => {
    $(".o-popup--job").removeClass("o-popup--open");
    $(".backplate").removeClass("backplate--open");

    $(".o-popup--job .cf7sg-response-output")
      .css("display", "none")
      .empty();

    console.log("sended");
  }, 3000);
});
